import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useProductStocks = (id, page, term) => useQuery({ queryKey: ['product-stock', id, page, term], queryFn: async () => {
    const callback = await API.get(`/products/${id}/stocks?page=${page}${term ? `&term=${term}` : ''}`)
    return callback?.data
}})

export default useProductStocks